import axios, { isAxiosError } from "axios";

import store from "store/store";
import { dismissAlertMessage, promptAlertMessage } from "store/slices/alert-slice";

import ErrorResponseDto from "dto/services/error-response-dto";
import { ServeRequestErrorsCallbackDto } from "dto/common/serve-request-errors-dto";

const serveRequestErrors = (error: ErrorResponseDto | Error | string, callback?: ServeRequestErrorsCallbackDto) => {
	let errorMessage = "";
	let errorCode = "";

	const dispatch = store.dispatch;

	const requestCancelled = axios.isCancel(error);

	const isError = (err: unknown): err is Error => err instanceof Error;

	if (requestCancelled) return requestCancelled;

	if (typeof error === "string") {
		errorMessage = error;
	} else if (isAxiosError(error)) {
		const requestError = error as ErrorResponseDto;

		errorCode = requestError?.response?.data?.errorCode ?? "";

		if (requestError.response?.data?.exceptionMessage) {
			errorMessage = requestError.response?.data?.exceptionMessage;
		} else {
			errorMessage = requestError.message;
		}
	} else if (isError(error)) {
		errorMessage = (error as Error).toString();
	}

	if (callback) return callback({ error: true, message: errorMessage, code: errorCode });

	dispatch(promptAlertMessage({ error: true, message: errorMessage, code: errorCode }));

	setTimeout(() => {
		dispatch(dismissAlertMessage());
	}, 5000);
};

export default serveRequestErrors;
